define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/date-format-service/1.0.0/index-impl'
  /* eslint-enable */
], function dateFormatService(app, dateFormatServiceImpl) {
  'use strict';

  app.registerFactory('dateFormatService', ['$filter', dateFormatServiceImpl]);
});
